import { Language } from '../../models/graphqlTypes'
import { useMe } from './useMe'

export const useSelectedLanguage = (): Language => {
  const { data: { me } = {} } = useMe({ fetchPolicy: 'cache-only' })

  return me?.language ?? Language.hu
}
